const age = [
  { label: "Below 15", value: "1" },
  { label: "15~20", value: "2" },
  { label: "21~25", value: "3" },
  { label: "26~30", value: "4" },
  { label: "31~40", value: "5" },
  { label: "41~50", value: "6" },
  { label: "51~60", value: "7" },
  { label: "Above 60", value: "8" },
];

export default age;